import { render, staticRenderFns } from "./PictureTable.vue?vue&type=template&id=2c5b256e&scoped=true"
import script from "./PictureTable.vue?vue&type=script&lang=js"
export * from "./PictureTable.vue?vue&type=script&lang=js"
import style0 from "./PictureTable.vue?vue&type=style&index=0&id=2c5b256e&prod&lang=scss"
import style1 from "./PictureTable.vue?vue&type=style&index=1&id=2c5b256e&prod&lang=scss&scoped=true"
import style2 from "./PictureTable.vue?vue&type=style&index=2&id=2c5b256e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b256e",
  null
  
)

export default component.exports